import { demarcationsMap } from "./demarcations";
import { latestMetricsMap } from "./latestMetrics";
import { patientMap } from "./patient";
import { procedureMap } from "./procedure";
import { userMap } from "./user";

export const nursingAdmissionMap: GenericObject = {
	pre_anesthetic_administered_description: "preAnestheticAdministeredDescription",
	terms_of_consent_not_signed_description: "termsOfConsentNotSignedDescription",
	decubitus_restrictions_descriptions: "decubitusRestrictionsDescriptions",
	prothesis_removal_description: "prothesisRemovalDescription",
	previous_surgery_description: "previousSurgeryDescription",
	attendance_id: "attendanceId",
	created_by: "createdBy",
	user_id: "userId",
	attendance_date: "attendanceDate",
	fasting_since: "fastingSince",
	had_previous_surgery: "hadPreviousSurgery",
	had_preoperatory_bath: "hadPreoperativeBath",
	preoperatory_bath_at: "preoperativeBathAt",
	had_prothesis_removal: "hadProthesisRemoval",
	had_trichotomy: "hadTrichotomy",
	trichotomy_at: "trichotomyAt",
	had_medical_reconciliation: "hadMedicalReconciliation",
	had_svd: "hadSvd",
	spontaneous_bladder_emptying: "spontaneousBladderEmptying",
	had_venous_access: "hadVenousAccess",
	venous_access_description: "venousAccessDescription",
	pre_anesthetic_administered: "preAnestheticAdministered",
	had_surgical_demarcation: "hadSurgicalDemarcation",
	terms_of_consent_signed: "termsOfConsentSigned",
	has_personal_history: "hasPersonalHistory",
	personal_history_description: "personalHistoryDescription",
	had_decubitus_restrictions: "hadDecubitusRestrictions",
	patient_metrics_id: "patientMetricsId",
	nursing_remarks: "nursingRemarks",
	previous_normal_childbirth_count: "previousNormalChildbirthCount",
	previous_premature_delivery_count: "previousPrematureDeliveryCount",
	previous_cesarean_delivery_count: "previousCesareanDeliveryCount",
	previous_partial_abortions_count: "previousPartialAbortionsCount",
	previous_instrumental_delivery_count: "previousInstrumentalDeliveryCount",
	previous_twin_births_count: "previousTwinBirthsCount",
	last_childbirth_at: "lastChildbirthAt",
	birth_type: "birthType",
	cesarean_section_indication: "cesareanSectionIndication",
	had_epsiotomy: "hadEpsiotomy",
	had_oxytocin_use: "hadOxytocinUse",
	birth_place: "birthPlace",
	children_born_alive: "childrenBornAlive",
	children_born_dead: "childrenBornDead",
	children_with_malformation: "childrenWithMalformation",
	last_menstruation_date: "lastMenstruationDate",
	probable_birthdate: "probableBirthdate",
	gestational_time_weeks: "gestationalTimeWeeks",
	gestational_time_days: "gestationalTimeDays",
	prenatal_location_type: "prenatalLocationType",
	prenatal_location_name: "prenatalLocationName",
	prenatal_card: "prenatalCard",
	father_sanguine_type: "fatherSanguineType",
	performed_pregnancy_examinations: "performedPregnancyExaminations",
	pregnant_person_disease_history: "pregnantPersonDiseaseHistory",
	complications_during_pregnancy: "complicationsDuringPregnancy",
	medications_during_pregnancy: "medicationsDuringPregnancy",
	pregnancy_remarks: "pregnancyRemarks",
	surgical_attendance_id: "surgicalAttendanceId",
	antenatal_doctor: "antenatalDoctor",
	metrics: latestMetricsMap,
	patient: patientMap,
	demarcations: demarcationsMap,
	exams: procedureMap,
	user: userMap,
};
